import { useQuery } from '@tanstack/react-query';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getContentMaterials = ({ pageId, managerId }: contentApiTypes.ListMaterialsParams) => {
  return axios.get('/content/materials', {
    params: { pageId, ...(managerId && { managerId }) },
  }) as Promise<contentApiTypes.ListMaterialsResponse>;
};

type QueryFnType = typeof getContentMaterials;

type UseGetContentMaterialsOptions = {
  pageId?: string | null;
  managerId?: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetContentMaterials = ({
  pageId,
  managerId,
  config = {},
}: UseGetContentMaterialsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['content-materials', pageId, managerId],
    enabled: Boolean(pageId) && (config.enabled ?? true),
    queryFn: () => getContentMaterials({ pageId: pageId!, managerId }),
    // Global default is refetchOnMount:false; the content list must show fresh data
    // when returning from the add/edit pages, so refetch every time it mounts.
    refetchOnMount: true,
  });
};

export type ContentMaterialsQueryData = ExtractFnReturnType<QueryFnType>;
